import pcoApproval from "./pcoApproval";
import pcoDetail from "./pcoDetail";
import scheduleFive from "./schedule-five/all";
import downstreamContract from "./downstream-contract/all";
import bondWaivers from './bond-waivers/all';

export default function (nameController, nameAction, namePage) {
    if (nameController === 'downstreamcontract') downstreamContract(nameAction, namePage);
    if (nameAction === 'pcoreviewandapproval') pcoApproval();
    if (nameAction === 'pcodetail') pcoDetail();
    if (nameController === 'schedulefive') scheduleFive(nameAction, namePage);
    
    if (nameController === 'bondwaiver') bondWaivers(nameAction, namePage);
}

/*General Functions for all Operations*/